export default "__VITE_ASSET__BAig5stN__"